import React, { useState } from 'react'
import { Container, Badge, CloseButton } from 'react-bootstrap'
import Alert from 'react-bootstrap/Alert';
import "./Cart.css"
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import CartDownloadButton from '../Buttons/CartDownloadButton/CartDownloadButton';
import { removeItem } from '../../Reducers/cartReducer';

const Cart = () => {
    const [error, setError] = useState(false);
    const [progress, setProgress] = useState(0);

    const cartItems = useSelector(state => state.cart.items);
    const count = useSelector(state => state.cart.items.length);
    const isFull = useSelector(state => state.cart.isFull);

    const dispatch = useDispatch();

    const { t } = useTranslation();

    return (
        <Container className='panel panel-body p-0 cart pull-right'>
            <div className="panel-heading mb-0">
                <i className="bi bi-cart-fill"></i>
                <span> {t('cart')}</span>
                {count !== 0 && <Badge bg="warning" className=' pull-right'>{count}</Badge>}
            </div>
            {progress > 0 && (
                <progress className="custom-progress" value={progress} max="100" />
            )}
            {count === 0 ? (
                <Container className='p-3'>
                    <Alert variant="info" className='d-flex flex-row align-items-center p-3'>
                        <p>{t('empty_cart')}</p>
                    </Alert>
                </Container>
            ) : (
                <>
                    {isFull && (
                        <Container className='p-3'>
                            <Alert variant="warning" >
                                <p className='m-0 text-center'>{t('full_cart')}</p>
                            </Alert>
                        </Container>
                    )}
                    <Container className='cart-list'>
                        <div className='p-3 d-flex justify-content-center'>
                            <CartDownloadButton setError={setError} setProgress={setProgress} />
                        </div>
                        {error &&
                            (
                                <Alert variant="warning" className='p-4' dismissible>
                                    <p className='m-0 text-center'>{t('error')}</p>
                                </Alert>
                            )
                        }
                        {cartItems && cartItems.map((item) => (
                            <div className='p-3 cart-item' key={item.globalAssetId}>
                                <CloseButton className='pull-right' onClick={() => dispatch(removeItem(item.globalAssetId))} />
                                <span className='d-flex flex-row align-items-center'>
                                    {item.type === document ? (
                                        <i className="bi bi-file-earmark-fill"></i>
                                    ) : (
                                        <img src={item.coverUrl} alt='cart item thumbnail' className='cart-img' />
                                    )}
                                    <span className={`item-title ${item.type === document ? "p-2" : "p-3"}`}>{item.title}</span>
                                </span>
                            </div>
                        ))}
                    </Container>
                </>
            )}
        </Container>
    )
}

export default Cart;